<h1 [translateParams]="context.data"
    translate
    matDialogTitle>
    role_users_modal_title
</h1>

<mat-dialog-content>
    <ui-role-users-grid #roleUsersGrid
                        [roleId]="context.data.id"
                        (close)="closeModal()">
    </ui-role-users-grid>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button"
            data-cy="user-role-cancel">
        {{ 'modal_action_close' | translate }}
    </button>
    <button [uiAuthorizeDisable]="'Roles.Edit'"
            (click)="roleUsersGrid.onSubmit()"
            mat-flat-button
            type="button"
            color="primary"
            data-cy="user-role-submit">
        {{ 'modal_action_update' | translate }}
    </button>
</mat-dialog-actions>
